const WarningIcon = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <circle cx='9' cy='9' r='7' fill='#EAAA2E'></circle>
      <path
        fill='#FFF6E5'
        d='M9 0a9 9 0 1 1 0 18.001A9 9 0 0 1 9 0m0 12a1.125 1.125 0 1 0 0 2.25A1.125 1.125 0 0 0 9 12m0-8.25a.75.75 0 0 0-.738.615L8.25 4.5v5.25l.012.135a.75.75 0 0 0 1.476 0l.012-.135V4.5l-.012-.135A.75.75 0 0 0 9 3.75'
      ></path>
    </svg>
  );
};

export default WarningIcon;
